
export const PENDING = 'PENDING';
export const VERIFIED = 'VERIFIED';
export const INCORRECT_CODE = "INCORRECT_CODE";
export const THROTTLED = 'THROTTLED';
export const EXPIRED_CODE = 'EXPIRED_CODE';